import moment from 'moment';
import React from 'react';

export default function Comment({ comment }) {
  const { name, message, time } = comment;

  const initials = name
    ? name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  const colors = ['#6C5DD3', '#0049C6', '#1eb865', '#FF7268', '#F0A500'];
  const colorIndex = name ? name.charCodeAt(0) % colors.length : 0;
  const avatarColor = colors[colorIndex];

  const formattedTime = time === 'Just Now'
    ? 'Just Now'
    : moment(time).format('DD MMM YYYY, hh:mm A');

  return (
    <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
      <div style={{
        width: '32px', height: '32px', borderRadius: '50%',
        background: avatarColor, color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '11px', fontWeight: 700, flexShrink: 0, marginTop: '2px',
      }}>
        {initials}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontSize: '13px', fontWeight: 600, color: '#0F0B28' }}>{name || 'Unknown'}</span>
          <span style={{ fontSize: '11px', color: '#A5A6BB' }}>{formattedTime}</span>
        </div>
        <div style={{
          background: '#FAFAFA',
          border: '1px solid #E3E3E3',
          borderRadius: '0 6px 6px 6px',
          padding: '8px 12px',
          fontSize: '13px',
          color: '#585969',
          lineHeight: '1.5',
        }}>
          {message}
        </div>
      </div>
    </div>
  );
}
